module.exports = __webpack_public_path__ + "img/nu.c8160a66.svg";